import { Edit } from '@mui/icons-material'
import {
  FormGroup,
  FormLabel,
  IconButton,
  TextField,
  useTheme,
} from '@mui/material'
import { useFormik } from 'formik'
import { useState } from 'react'
import { toast } from 'react-toastify'
import * as yup from 'yup'

import CustomDialog from '~/components/customDialog'
import useUpdateCampaign from '~/features/campaigns/hooks/useUpdateCampaign'
import { ECampaignKeys } from '~/features/campaigns/models'
import useGetSelectedCampaign from '~/hooks/useGetSelectedCampaign'
import rem from '~/utils/ui'

export default function CampaignEditTitle() {
  const theme = useTheme()
  const { campaign } = useGetSelectedCampaign()
  const [isOpen, setIsOpen] = useState(false)

  const { mutate: updateCampaign, isPending: isSubmitting } = useUpdateCampaign(
    campaign?.id || '',
  )
  const handleCancel = () => setIsOpen(false)
  const handleOpen = () => setIsOpen(true)

  const formik = useFormik({
    initialValues: {
      title: campaign?.[ECampaignKeys.campaignName] || '',
      description: campaign?.[ECampaignKeys.description] || '',
    },
    validationSchema: yup.object({
      title: yup.string().required('Title is required'),
      description: yup.string().optional(),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      updateCampaign(
        {
          [ECampaignKeys.campaignName]: values.title,
          [ECampaignKeys.description]: values.description,
        },
        {
          onSuccess: () => {
            toast.success('Campaign name updated successfully')
            formik.resetForm()
            handleCancel()
          },
        },
      )
    },
  })

  const { handleSubmit } = formik

  return (
    <>
      <IconButton onClick={handleOpen}>
        <Edit />
      </IconButton>

      <CustomDialog
        isOpen={isOpen}
        onClose={handleCancel}
        onCancel={handleCancel}
        title="Rename Your Campaign"
        isDisabled={isSubmitting || !formik.values.title}
        onConfirm={() => handleSubmit()}
        cancelText="Cancel"
        confirmText="Update campaign"
        maxWidth={500}
        description="Update your campaign name"
      >
        <>
          <FormGroup sx={{ gap: rem(8) }}>
            <FormLabel
              sx={{
                fontSize: rem(14),
                color: theme.palette.mainFont,
                fontWeight: 500,
              }}
            >
              Campaign Name
            </FormLabel>
            <TextField
              disabled={isSubmitting}
              sx={{
                '.MuiInputBase-root': {
                  height: rem(36),
                  borderRadius: rem(8),
                },
              }}
              placeholder="e.g. Fall Sale Announcement"
              {...formik.getFieldProps('title')}
            />
          </FormGroup>

          <FormGroup sx={{ gap: rem(8) }}>
            <FormLabel
              sx={{
                fontSize: rem(14),
                color: theme.palette.mainFont,
                fontWeight: 500,
              }}
            >
              Campaign Description
            </FormLabel>
            <TextField
              disabled={isSubmitting}
              sx={{
                '.MuiInputBase-root': {
                  borderRadius: rem(8),
                },
              }}
              multiline
              rows={3}
              placeholder="e.g. This campaign is a one-time campaign to announce the fall sale."
              {...formik.getFieldProps('description')}
            />
          </FormGroup>
        </>
      </CustomDialog>
    </>
  )
}
